import React from 'react';

const reviewData = [
  {
    name: 'Dustin Ellis',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/4-1770047689397.jpg',
    quotes: [
      "Dustin's CAD experience and how quickly he handles those tasks has been huge—especially on the rush jobs. He's always willing to take care of just about anything on the data prep side, even if it's something small like geo-referencing a single image.",
      "He is an amazing team sport and will answer any of your questions you need answered.",
      "Dustin is highly competent, attentive, and meticulous. His strong skills and dedication are consistently demonstrated in his work, providing significant value to the team.",
      "He collaborates exceptionally well with team members. It is always pleasant and quick to get his assistance on a project I appreciate what he does with data extraction and handling raw CAD and points. I couldn't do what he does.",
    ],
  },
  {
    name: 'Heath Boyte',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/13-1770047687023.jpg',
    quotes: [
      "Heath slid into the data prep and customer support role like he was made for it. His experience working with clients both in the field and in the office has really come in handy.",
      "Very thorough, and on top of things, can usually count on a quick turnaround for any task.",
      "Heath is supportive, cooperative, and always ready to help. His attentiveness, politeness, and teamwork make him a dependable and valued member of the group.",
      "He has a great attitude about work, never shirks from even large tasks.",
    ],
  },
  {
    name: 'Adam Boyte',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/2-1770047687784.jpg',
    quotes: [
      "Brings good energy to the team, great communication when an issue arises.",
      "Adam is a true expert in his field and a wise mentor. Always ready to assist, he sets an excellent example and delivers impressive work, especially in model building.",
      "I appreciate his familiarity with the real world application of the data we are working with. His ability to \"ground\" the data in that way in tremendously helpful for clarity and retention. In that same vein, he is very helpful and willing to give feedback on work in productive ways.",
      "Quick and thorough with his work and always willing to take time and help out when you need it, he knows a thing or two because he's seen a thing or two",
    ],
  },
  {
    name: 'Stef Quibette',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/6-1770047684727.jpg',
    quotes: [
      "Has shown a lot of grown a lot in her role and is doing great. Stef is always willing to tackle any task.",
      "Stef works diligently to make sure jobs are ready to go. Tackling any issues that come up, and helping out wherever is necessary.",
      "I definitely enjoyed cross training with her. It was nice to get a few days of working in tandem to get her perspective on things",
      "She does excellent work with less hands on support than other model builders, due to the time in which she works.",
    ],
  },
  {
    name: 'Melvin Lumag',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/15-1770047688860.jpg',
    quotes: [
      "Works really well within the system by always having things ready for the next day—whether that's new jobs set up, data prep, revisions, or double checks.",
      "He's a quick learner. I loved what he was able to create from the RPS commands.",
      "He's a good sport and will do whatever he can to help you out if you need it.",
      "His work on replicating the RPS commands has been huge for getting some of that key functionality back in TBC.",
    ],
  },
  {
    name: 'Glarence Cammayo',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/16-1770047686492.jpg',
    quotes: [
      "Glarence has clearly put in a lot of hours helping develop our self-hosted platforms, and she's always been eager to work with us to troubleshoot issues and make improvements.",
      "She did great work on organizing all of our training courses. She had to communicate with all of the members of the team to get that taken care of.",
      "I very much appreciate the back and forth we have had for the Capture software and she has taken great steps to get all of that done.",
      "Her work behind the scenes on our self-hosted platforms has been a huge success, and help for our day to day.",
    ],
  },
  {
    name: 'Linda Grady',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/8-1770047689903.jpg',
    quotes: [
      "She is always cheerful and sweet.",
      "She does a lot behind the scenes and I appreciate that she helps keep it all running. Biweekly check ins with her are always pleasant and often humorous.",
      "Linda works tirelessly to make sure invoices are paid, often having to call and email multiple times. She always communicates with us to make sure paychecks are on time and PTO has been correctly accounted for.",
      "Even though I don't get to interact with her often, is an amazing asset. She is always so thorough with all of our time and payroll. I never worry about anything with that side having any issues. I know she does other things that I'm not privy to as well.",
    ],
  },
  {
    name: 'Matt Cole',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/5-1770047685969.jpg',
    quotes: [
      "Matt has always been awesome since I started working here, but lately stepping up and handling the day-to-day operations has shown just how invaluable he is to everything we do. Whether it's making a call for clarification, answering questions, mentoring, or guiding the team, he's always there.",
      "Matt is dedicated, efficient, and knows just the right words to say at the right time. With his clear and engaging speaking voice (especially valuable in our remote work environment) along with his great sense of humor, encouragement, and dependability, he creates a positive and supportive atmosphere for the team every day.",
      "Matt has stepped up in one of the most critical and demanding roles in the company to ensure that our models are of top quality and consistent to our clients. He has also stepped up to lead the team and as a natural leader has made everyone better.",
    ],
  },
  {
    name: 'Zach Breth',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/7-1770047688334.jpg',
    quotes: [
      "Zach's attention to fine detail makes him a perfect fit for the minutiae involved in advanced utility models. He's also always eager to help however he can—whether that's a second set of eyes, checking cross sections, or reviewing work to help Matt.",
      "Super detail oriented and catches a lot of minor things that are actually very major details. Very dedicated and punctual.",
      "He's good and down to earth and will let you know if you missed something and will definitely keep you accountable.",
      "Zach is always ready to help, detail-oriented, and punctual. He consistently makes time for others and approaches his work with care and reliability, making him a trusted and valued teammate.",
    ],
  },
  {
    name: 'Devin Bower',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/17-1770047690939.jpg',
    quotes: [
      "I feel is the back bone! I know Adam is the ram rod but she no doubt has spent countless hours supporting his vision and quest to build this company.",
      "Always friendly and personable. Her and Adam make a great team. They work very well together and it shows.",
      "Devin has a generous spirit and a caring heart. She uplifts the team's morale and makes everyone feel supported and valued. She looks after the well-being of the entire team.",
    ],
  },
  {
    name: 'Adam Bower',
    avatar: 'https://db.ab-civil.com/storage/v1/object/public/brand-assets/headshots/optimized/1-1770047690412.jpg',
    quotes: [
      "Adam's vision, leadership, and guidance for this company are second to none. I've never worked for someone who is so willing to listen, make changes when they're needed, or clearly explain decisions when things stay the same. He puts a lot of thought and effort into everything before bringing the rest of us in, and it shows.",
      "Cares about his team, quick to correct any issues or conflicts.",
      "Adam is a hands-on leader with a clear vision and a knack for technology. He inspires the team with his innovative ideas, thoughtful analysis, and patience. Always encouraging and compassionate, Adam leads by example and motivates everyone around him. He prioritizes technologies and innovation that help not just the clients but the overall growth of the team.",
      "I know he is trying to be more hands off in the day to day but I appreciate his willingness to step forward when the situation calls for it. I know there has also been tremendous back end work with Heath, Glarence, Melvin and others and the software for the company gets better all the time.",
    ],
  },
];

const styles = {
  page: {
    minHeight: '100vh',
    background: '#0f172a',
    color: '#e2e8f0',
    fontFamily: "'Inter', sans-serif",
  },
  hero: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)',
    padding: '80px 40px 60px',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  heroBefore: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'radial-gradient(circle at 30% 50%, rgba(59, 130, 246, 0.15) 0%, transparent 50%), radial-gradient(circle at 70% 50%, rgba(16, 185, 129, 0.1) 0%, transparent 50%)',
  },
  yearBadge: {
    display: 'inline-block',
    background: 'rgba(59, 130, 246, 0.15)',
    border: '1px solid rgba(59, 130, 246, 0.3)',
    color: '#60a5fa',
    padding: '6px 20px',
    borderRadius: '100px',
    fontSize: '0.85rem',
    fontWeight: 600,
    letterSpacing: '2px',
    marginBottom: '20px',
    position: 'relative',
    zIndex: 1,
  },
  title: {
    fontSize: '3.5rem',
    fontWeight: 900,
    background: 'linear-gradient(135deg, #60a5fa, #34d399)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    marginBottom: '8px',
    letterSpacing: '-1px',
    position: 'relative',
    zIndex: 1,
  },
  subtitle: {
    fontSize: '1.3rem',
    color: '#94a3b8',
    fontWeight: 300,
    position: 'relative',
    zIndex: 1,
  },
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '40px 24px',
  },
  person: {
    marginBottom: '48px',
  },
  personHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '20px',
  },
  avatar: {
    width: '64px',
    height: '64px',
    borderRadius: '14px',
    objectFit: 'cover',
    flexShrink: 0,
    border: '2px solid #334155',
  },
  personName: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#f1f5f9',
  },
  quotes: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  quote: {
    background: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '12px',
    padding: '20px 24px',
    position: 'relative',
    fontSize: '0.92rem',
    lineHeight: 1.7,
    color: '#cbd5e1',
  },
  quoteMark: {
    position: 'absolute',
    top: '8px',
    left: '12px',
    fontSize: '2.5rem',
    color: '#334155',
    fontFamily: 'Georgia, serif',
    lineHeight: 1,
  },
  quoteText: {
    paddingLeft: '20px',
  },
  divider: {
    height: '1px',
    background: 'linear-gradient(90deg, transparent, #334155, transparent)',
    margin: '48px 0',
  },
  footer: {
    textAlign: 'center',
    padding: '40px 24px',
    color: '#475569',
    fontSize: '0.8rem',
  },
};

export default function PeerReviews() {
  return (
    <div style={styles.page}>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" />
      <div style={styles.hero}>
        <div style={styles.heroBefore} />
        <div style={styles.yearBadge}>PEER REVIEWS</div>
        <h1 style={styles.title}>AB Civil 2025</h1>
        <p style={styles.subtitle}>What the team says about each other</p>
      </div>
      <div style={styles.container}>
        {reviewData.map((person, i) => (
          <React.Fragment key={person.name}>
            {i > 0 && <div style={styles.divider} />}
            <div style={styles.person}>
              <div style={styles.personHeader}>
                <img style={styles.avatar} src={person.avatar} alt={person.name} />
                <div style={styles.personName}>{person.name}</div>
              </div>
              <div style={styles.quotes}>
                {person.quotes.map((q, j) => (
                  <div key={j} style={styles.quote}>
                    <span style={styles.quoteMark}>{'\u201C'}</span>
                    <p style={styles.quoteText}>{q}</p>
                  </div>
                ))}
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
      <div style={styles.footer}>AB Civil Consulting &mdash; 2025 Peer Reviews</div>
    </div>
  );
}
